export const I18N_VERSION = "20210118152200";
